import axios from "axios";
import constData from "../components/ReusableComponents/constants";
import { apiPath, API_URL } from "./apiPath";
import authHeader from "./authHeader";
const getEmpCountryCode = () => {
  return axios
    .post(
      API_URL + apiPath.getCountryCodes,
      {
        type: "employer",
      },
      authHeader()
    )
    .then((response) => {
      return response.data;
    });
};
const getLanguage = () => {
  return axios
    .get(API_URL + apiPath.employerSpokenLanguage, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getNationality = () => {
  return axios
    .get(API_URL + apiPath.employerNationality, authHeader())
    .then((response) => {
      return response.data;
    });
};
const saveEmpDetails = (empDetails) => {
  return axios
    .post(API_URL + apiPath.addEmployer, empDetails, authHeader())
    .then((response) => {
      return response.data;
    });
};
const getEmpDetails = (empId) => {
  return axios
    .post(
      API_URL + apiPath.getEmployerDetails,
      empId,
      authHeader(constData.allPermissions.empInfo)
    )
    .then((response) => {
      return response.data;
    });
};
const getEmployerList = (props) => {
  if (props !== "" && props !== undefined && typeof props !== "object") {
    return axios.post(props, {}, authHeader()).then((response) => {
      return response.data;
    });
  } else {
    return axios
      .post(API_URL + apiPath.getEmployerList, props, authHeader())
      .then((response) => {
        return response.data;
      });
  }
};
const getEmployerJobofferListApi = (props) => {
  console.log(props);
  if (props.path) {
    return axios
      .post(props.path, props, authHeader(constData.allPermissions.empJobOffer))
      .then((response) => {
        return response.data;
      });
  } else {
    return axios
      .post(
        API_URL + apiPath.getEmployerJobofferList,
        { emp_id: props.emp },
        authHeader()
      )
      .then((response) => {
        return response.data;
      });
  }
};
const updateEmpDetails = (empDetails) => {
  return axios
    .post(API_URL + apiPath.updateEmpDetails, empDetails, authHeader())
    .then((response) => {
      return response.data;
    });
};

const empDetailsApi = {
  getEmpCountryCode,
  getLanguage,
  getNationality,
  saveEmpDetails,
  getEmpDetails,
  getEmployerList,
  getEmployerJobofferListApi,
  updateEmpDetails,
};
export default empDetailsApi;
